// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// api
import { useUnitsGetAsyncByidQuery } from '@/api/generated/recalc/endpoints/v1/units';
import { useUnitTypesGetCollectionAsyncByqueryOptionsQuery } from '@/api/generated/recalc/endpoints/v1/unitTypes';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';
import GatewayLoadingIndicator from '@/components/ui/progress/GatewayLoadingIndicator';

// feature-components
import EditUnitForm from '@/features/units/forms/EditUnitForm';
import type { SelectedUnitType } from '@/features/units/forms/unitTypeInput.schema';

export const Route = createFileRoute('/$accountId/_user/units/$unitId/edit')({
  component: RouteComponent,
  staticData: { crumb: 'units-gateways-sensors:units.unitEdit' },
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');
  const { unitId, accountId } = useParams({ strict: false });

  const { data: unit, isLoading: isLoadingUnit } = useUnitsGetAsyncByidQuery(
    { id: Number(unitId) },
    { skip: !unitId },
  );

  const { data: unitTypes, isLoading: isLoadingUnitTypes } =
    useUnitTypesGetCollectionAsyncByqueryOptionsQuery({});

  const unitTypeOptions = (unitTypes as SelectedUnitType[] | undefined) ?? [];
  const selectedUnitType = unitTypeOptions.find(
    (unitTypeOption) =>
      unitTypeOption.UnitTypeId === unit?.UnitType?.UnitTypeId,
  );

  console.log('Unit:', unit);
  console.log('Selected Unit Type:', selectedUnitType);

  const isLoading = isLoadingUnit || isLoadingUnitTypes;

  return (
    <PageContainer maxWidth="xl" sx={{ py: 2 }}>
      <GatewayLoadingIndicator isLoading={isLoading} />
      <PageHeader
        title={t('common:actions.editItem', { item: unit?.Name ?? '' })}
      />
      {unit && selectedUnitType && (
        <EditUnitForm
          key={unit.UnitId}
          unit={unit}
          unitType={selectedUnitType}
          accountId={Number(accountId)}
        />
      )}
    </PageContainer>
  );
}
